import TableFilter from './TableFilter'
// Uncomment the below to migrate to stateful component
// import TableFilterContainer from './TableFilterContainer'

export { TableFilter }
export default TableFilter
// Uncomment the below to migrate to stateful component
// export { TableFilterContainer }
// export default { TableFilterContainer }
